import { Avatar } from 'antd'
import { ProviderAyrshareCommon } from '../common'
import { FormConnectSteps } from './FormConnectSteps'

import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { useAuthentication } from './hooks/useAuthentication'

export const ProviderAyrshareClient: ProviderClient = {
  key: ProviderAyrshareCommon.key,
  authentication: ProviderAuthenticationClient.Form({
    ...ProviderAyrshareCommon.authentication,
    inputs: [],
  }),
  description: {
    label: 'Task',
    icon: (
      <Avatar
        size="small"
        src="cledara-public.s3.eu-west-2.amazonaws.com/1628183637214%20(1).jpeg"
      />
    ),
    triggers: [],
    actions: [],
  },
  FormConnectSteps,
}

export const ProviderAyrshareClientCustom = {
  useAuthentication,
}
